// extracted by mini-css-extract-plugin
module.exports = {"badEntry":"loginForm_badEntry__2M2VX","microsoftLoginButton":"loginForm_microsoftLoginButton__1PQl-"};